import { useCallback, useMemo } from 'react';
import useSWR from 'swr';
import { useAuth } from '../auth/auth.hook';
import { useConfig } from '../config/config.hook';
import { PerfilAluno, PerfilEducador, useUsuario } from '../usuario';
import { consultarTrabalhosV21Service } from './services/consultar-trabalhos';
import { mapperApiResponseToDomain } from './trabalho.mapper';
import { Hook } from './trabalho.types';

export const useTrabalho: Hook = ({ idTurma, precondicao }) => {
  const { token } = useAuth();
  const { getValueOrThrow } = useConfig();
  const { get } = useUsuario();

  const urlBase = getValueOrThrow<string>('API_DEDICADA');
  const {
    aura: {
      dados: { emailUtilizado },
    },
  } = get<PerfilAluno | PerfilEducador>();

  const {
    data,
    isLoading,
    isValidating,
    error,
    mutate: retentativa,
  } = useSWR(
    precondicao ? ['trabalhos', idTurma, emailUtilizado] : null,
    async () => {
      const apiResponses = await consultarTrabalhosV21Service({
        urlBase,
        token,
        idEntrega: idTurma,
      });

      return apiResponses.map((apiResponse) => mapperApiResponseToDomain(apiResponse));
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 1800000,
    },
  );

  const getTrabalhos = useCallback(
    () => ({ value: data, pending: isLoading || isValidating, error }),
    [data, error, isLoading, isValidating],
  );
  const getValorTrabalhos = useCallback(() => data ?? [], [data]);

  return useMemo(
    () => ({ getTrabalhos, getValorTrabalhos, retentativa }),
    [getTrabalhos, getValorTrabalhos, retentativa],
  );
};
